// extracted by mini-css-extract-plugin
export default {"img":"waterbody_card__img--MkIU","name":"waterbody_card__name--Jc5F","locations":"waterbody_card__locations--QXHV"};